import React, { useEffect, useMemo, useRef, useState } from "react"
import { Row, Col, Tab, Tabs, Form } from "react-bootstrap"
import { Breadcrumb, Pagination } from "../../../components"
import PageLayout from "../../../layouts/PageLayout"
import data from "../../../data/master/admin/payments.json"
import { Box, Item, Anchor, Button } from "../../../components/elements"
import { CardLayout, TabCard } from "../../../components/cards"
import {
  EcommerceCard,
  SalesCard,
  ProductsCard,
  RevenueCard,
  ActivityCard,
  OrdersCard,
} from "../../../components/cards"
import ClientsTable from "../../../components/admin/Clients"
import AdminAccountsPage from "../../../components/admin/Accounts"
import PaymentsPage from "../../../components/admin/Payments"
import {
  Skeleton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Flex,
  Spinner,
} from "@chakra-ui/react"
import { LabelField } from "../../../components/fields"
import DepositTable from "./table"
import { useQuery } from "react-query"
import {
  approveRejectRequestService,
  getAllIBPlans,
  getAllIBRequestsService,
  getAllIbPlanService,
  getAllUsersServices,
  getRequestsByType,
  makeUserIbService,
} from "../../../services/admin.service"
import { useShowToast } from "../../../hooks"
import _ from "lodash"
import ChangeIbPlanForm from "./add-new-user-form"
import { useParams } from "react-router-dom"

export default function AdminEditUser() {
  const id = 100025

  const { isLoading, error, data, refetch } = useQuery(
    ["admin-users", id],
    () =>
      getAllUsersServices(
        1,
        undefined,
        30,
        "ashishbhogesara@gmail.com",
        "",
        false,
        id
      )
  )

  const getAllIBPlans = useQuery(["admin-ib-plans"], () =>
    getAllIbPlanService()
  )

  const user = data?.data?.data?.users?.data?.length
    ? data?.data?.data?.users?.data[0]
    : null

  const plans = useMemo(() => {
    let _plans = []

    _plans = _.map(
      getAllIBPlans?.data?.data?.data?.ib_plan_master?.data ?? [],
      (_level) => {
        return {
          ..._level,
          total: _.reduce(
            _level?.levels_commissions,
            (sum, _item) => {
              return _item?.commission
                ? parseFloat(_item?.commission) + sum
                : sum
            },
            0
          ),
        }
      }
    )

    return _plans
  }, [getAllIBPlans])

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <Box className="mc-card">
            <Breadcrumb title={"Edit User #" + id}>
              <Item className="mc-breadcrumb-item">
                <Anchor className="mc-breadcrumb-link" href="/admin">
                  Home
                </Anchor>
              </Item>

              <Item className="mc-breadcrumb-item">
                <Anchor className="mc-breadcrumb-link" href="/admin/users">
                  Users
                </Anchor>
              </Item>

              <Item className="mc-breadcrumb-item">
                <Anchor className="mc-breadcrumb-link"> {id} </Anchor>
              </Item>

              <Item className="mc-breadcrumb-item">
                <Anchor className="mc-breadcrumb-link"> Edit</Anchor>
              </Item>
            </Breadcrumb>
          </Box>
        </Col>

        <DepositsPaymentPage />
      </Row>
    </PageLayout>
  )
}

const Loader = () => {
  return <Skeleton minHeight="500px" />
}

const DepositsPaymentPage = () => {
  return (
    <>
      <Col xl={12}>
        <CardLayout>
          <ChangeIbPlanForm />
        </CardLayout>
      </Col>
    </>
  )
}
